import { render, staticRenderFns } from "./customersai-add-or-update.vue?vue&type=template&id=1991bf54&"
import script from "./customersai-add-or-update.vue?vue&type=script&lang=js&"
export * from "./customersai-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports